import React, { forwardRef, type ComponentProps } from "react";
import ReactTour from "reactour";
import clsx from "clsx";
import { makeStyles, useTheme } from "@material-ui/core/styles";

import type { Theme } from "src/theme";
import { useFullscreenElement } from "src/utils/fullscreen";

const useStyles = makeStyles((theme) => ({
  helper: {
    maxWidth: "80%",
    [theme.breakpoints.up("sm")]: {
      maxWidth: "500px",
    },
    padding: 0,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.primary,
    borderRadius: 12,
    overflow: "hidden",
  },
}));

/** This is just a wrapper of Tour that patches `container` property to make
 * the dialog work in fullscreen mode.
 */
const Tour = forwardRef(
  ({ className, ...props }: ComponentProps<ReactTour>, ref) => {
    const fullscreenElement = useFullscreenElement();
    const classes = useStyles();
    const theme = useTheme() as Theme;
    const { custom: palette } = theme.palette.custom;

    return (
      <ReactTour
        ref={ref}
        container={fullscreenElement || document?.body}
        accentColor={palette.accent}
        startAt={0}
        rounded={12}
        className={clsx(classes.helper, className)}
        closeWithMask={false}
        disableDotsNavigation
        disableFocusLock
        showNavigation={false}
        showNavigationNumber={false}
        showButtons={false}
        showCloseButton={false}
        showNumber={false}
        {...props}
      />
    );
  }
);

export default Tour;
